// Chemin: C:\gestion-copro\src\hooks\useAlertes.ts
// Session 70 : Hook pour charger les compteurs d'alertes
// Rafraichissement automatique toutes les 60 secondes

import { useState, useEffect, useCallback } from 'react';
import { useAuth } from '../context/AuthContext';
import { useCopropriete } from '../context/CoproprieteContext';
import { getAlertesCount, AlertesCounts } from '../services/alertes.service';

const REFRESH_INTERVAL = 60000; // 60 secondes

export function useAlertes() {
  const { firebaseUser } = useAuth();
  const { coproprieteId } = useCopropriete();
  
  const [alertes, setAlertes] = useState<AlertesCounts>({
    courriers: 0,
    messagerie: 0,
    comptabilite: 0,
    signalements: 0,
    affaires: 0,
    total: 0,
  });
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    if (!coproprieteId || !firebaseUser?.uid) {
      setLoading(false);
      return;
    }

    try {
      const counts = await getAlertesCount(coproprieteId, firebaseUser.uid);
      setAlertes(counts);
    } catch (error) {
      console.error('Erreur chargement alertes:', error);
    } finally {
      setLoading(false);
    }
  }, [coproprieteId, firebaseUser?.uid]);

  // Chargement initial
  useEffect(() => {
    refresh();
  }, [refresh]);

  // Rafraichissement periodique
  useEffect(() => {
    const interval = setInterval(refresh, REFRESH_INTERVAL);
    return () => clearInterval(interval);
  }, [refresh]);

  return {
    alertes,
    loading,
    refresh,
  };
}